import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ListIcon } from "lucide-react";

interface Props {
  totalRecord: number;
  pageSizeOptions: number[];
  onPageSizeChange: (value: number) => void;
  isLoading?: boolean;
  defaultPageSize: number;
}

export const PageSizeSelect: React.FC<Props> = ({
  totalRecord,
  pageSizeOptions,
  onPageSizeChange,
  isLoading,
  defaultPageSize,
}) => {
  const { t } = useTranslation();
  const filteredPageSizeOptions = (pageSizeOptions || []).filter((pageSize) => {
    const nextLowestOption = pageSizeOptions[pageSizeOptions.indexOf(pageSize) - 1] || 0;
    return nextLowestOption < totalRecord;
  });

  return (
    <Select
      onValueChange={(value) => onPageSizeChange(Number(value))}
      disabled={isLoading}
      defaultValue={String(defaultPageSize)}
    >
      <SelectTrigger
        className={cn(
          "w-[100px] h-[38px] transition-all duration-200",
          "hover:bg-accent/20 focus:ring-2 focus:ring-primary/20",
          "data-[state=open]:bg-accent/20"
        )}
      >
        <div className="flex items-center gap-2">
          <ListIcon className="h-4 w-4 text-muted-foreground" />
          <SelectValue placeholder={t("dataTable.pageSize")} />
        </div>
      </SelectTrigger>
      <SelectContent>
        {filteredPageSizeOptions.map((pageSize) => {
          return (
            <SelectItem
              key={pageSize}
              value={String(pageSize)}
              className="transition-colors duration-200 hover:bg-accent/20 cursor-pointer"
            >
              {pageSize}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
